"use strict";var Expander = require('makeup-expander');
var assign = require('core-js-pure/features/object/assign');
var findIndex = require('core-js-pure/features/array/find-index');
var eventUtils = require('../../common/event-utils');
var menuUtils = require('../../common/menu-utils');

module.exports = assign({}, menuUtils, {
  toggleItemChecked: function toggleItemChecked(index, itemEl, originalEvent) {
    // This needs to be at start since toggleChecked swaps the checkedIndex
    // and then the right events will not fire correctly
    var shouldEmitRadio = this.isRadio() && index !== this.state.checkedIndex;
    this.toggleChecked(index);

    if (shouldEmitRadio) {
      if (this.input.collapseOnSelect) {
        this.expander.collapse();
      }
      this.emitComponentEvent({
        index: index,
        eventType: 'change',
        el: itemEl,
        originalEvent: originalEvent });

    } else if (this.type !== 'radio') {
      if (this.input.collapseOnSelect) {
        this.expander.collapse();
      }
      this.emitComponentEvent({
        index: index,
        eventType: !this.type ? 'select' : 'change',
        el: itemEl,
        originalEvent: originalEvent });

    }

    if (this.rovingTabindex) {
      this.tabindexPosition = findIndex(
      this.rovingTabindex.filteredItems,
      function (el) {return el.tabIndex === 0;});

    }
  },

  handleItemClick: function handleItemClick(index, e, itemEl) {
    this.toggleItemChecked(index, itemEl, e);
  },

  handleMenuKeydown: function handleMenuKeydown(_ref) {var _this = this;var el = _ref.el,originalEvent = _ref.originalEvent,index = _ref.index;
    eventUtils.handleActionKeydown(originalEvent, function () {
      _this.handleItemClick(index, originalEvent, el);
    });

    eventUtils.handleEscapeKeydown(originalEvent, function () {
      _this.expander.collapse();
      _this.focus();
    });
  },

  focus: function focus() {
    this.getEl('button').focus();
  },

  handleButtonEscape: function handleButtonEscape() {
    this.expander.collapse();
  },

  handleExpand: function handleExpand() {
    this.emitComponentEvent({ eventType: 'expand' });
  },

  handleCollapse: function handleCollapse() {
    this.emitComponentEvent({ eventType: 'collapse' });
  },

  handleMenuChange: function handleMenuChange(_ref2) {var el = _ref2.el,originalEvent = _ref2.originalEvent,index = _ref2.index;
    this.toggleItemChecked(index, el, originalEvent);
  },

  handleMenuSelect: function handleMenuSelect(_ref3) {var el = _ref3.el,originalEvent = _ref3.originalEvent,index = _ref3.index;
    if (this.input.collapseOnSelect) {
      this.expander.collapse();
    }

    this.emitComponentEvent({ eventType: 'select', el: el, originalEvent: originalEvent, index: index });
  },
  handleMousedown: function handleMousedown(_ref4) {var el = _ref4.el,originalEvent = _ref4.originalEvent;
    this.emitComponentEvent({ eventType: 'mousedown', el: el, originalEvent: originalEvent });
  },
  emitComponentEvent: function emitComponentEvent(_ref5) {var eventType = _ref5.eventType,el = _ref5.el,originalEvent = _ref5.originalEvent,index = _ref5.index;
    var checkedIndexes = this.getCheckedIndexes();
    var isCheckbox = this.type === 'checkbox';

    var eventObj = {
      el: el,
      originalEvent: originalEvent };


    if (isCheckbox && checkedIndexes.length > 1) {
      assign(eventObj, {
        indexes: this.getCheckedIndexes(), // DEPRECATED in v5
        checked: this.getCheckedIndexes(), // DEPRECATED in v5 (keep but change from indexes to values)
        checkedValues: this.getCheckedValues() // DEPRECATED in v5
      });
    } else if (isCheckbox || this.isRadio()) {
      assign(eventObj, {
        index: index, // DEPRECATED in v5
        checked: this.getCheckedIndexes(), // DEPRECATED in v5 (keep but change from indexes to values)
        checkedValues: this.getCheckedValues() // DEPRECATED in v5
      });
    } else if (eventType !== 'expand' && eventType !== 'collapse') {
      assign(eventObj, {
        index: index, // DEPRECATED in v5
        checked: [index] // DEPRECATED in v5 (keep but change from indexes to values)
      });
    }

    this.emit("" + eventType, eventObj);
  },

  onInput: function onInput(input) {
    this.state = this.getInputState(input);
  },

  onRender: function onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  },

  onMount: function onMount() {
    this._setupMakeup();
  },

  onUpdate: function onUpdate() {
    this._setupMakeup();
  },

  onDestroy: function onDestroy() {
    this._cleanupMakeup();
  },

  _setupMakeup: function _setupMakeup() {
    this.expander = new Expander(this.el, {
      hostSelector: '.menu-button__button',
      contentSelector: '.menu-button__menu',
      focusManagement: 'focusable',
      expandOnClick: true,
      autoCollapse: true,
      alwaysDoFocusManagement: true });

  },

  _cleanupMakeup: function _cleanupMakeup() {
    if (this.expander) {
      this.expander.cancelAsync();
    }
  } });